const LETTER_TEXT = `<p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; font-weight: bold; color: rgb(51, 51, 51); font-family: Arial, 宋体; font-size: 12px; white-space: normal; background-color: rgb(255, 255, 255); line-height: 1.75em;">
<span style="font-size: 12px;">各位工会会员，大家好！</span>
</p>
<p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgb(51, 51, 51); font-family: Arial, 宋体; font-size: 12px; text-indent: 24px; white-space: normal; background-color: rgb(255, 255, 255); line-height: 1.75em;">
<span style="font-size: 12px;">企业发展离不开职工，职工的各项权益也只有在企业发展中才能得到实现。企业为职工提供“劳动得到尊重、价值得以体现”的舞台，营造“企业关心职工利益、职工关心企业发展”的良好氛围，达到“和谐稳定、互利共赢、共同成长”的目的。企业工会应在构建和谐稳定的劳动关系中发挥主导作用，坚持和谐发展、互利共赢理念。</span>
</p>
<p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgb(51, 51, 51); font-family: Arial, 宋体; font-size: 12px; text-indent: 24px; white-space: normal; background-color: rgb(255, 255, 255); line-height: 1.75em;">
<span style="font-size: 12px;">为了更好地为所有罗氏工会成员服务，上海罗氏工会建立了工会平台。在这里，您能了解到中国工会的基础理论知识和相关政策法规；有机会研究劳动关系争议处理案例的分析；可以与上海罗氏工会的委员进行真诚的交流与沟通；知晓工会最新的团队建设活动和关爱员工个人与家庭的信息；通过“工会会员手册”，了解公司给予工会会员和直系亲属的福利待遇；在“新视野俱乐部”里寻求志趣相投的文体娱乐伙伴，欢度8小时之外的闲暇时光。我们感谢您的关注，并期待您为工会工作提出更多富有创意的建设性提议，通过您的聪明才智为提升上海罗氏工会的工作质量做出贡献。</span>
</p>
<p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgb(51, 51, 51); font-family: Arial, 宋体; font-size: 12px; text-indent: 24px; white-space: normal; background-color: rgb(255, 255, 255); line-height: 1.75em;">
<span style="font-size: 12px;">工会是全体会员的有力后盾，是促进企业内部劳动关系和谐的润滑剂与助力器。工会是全体会员交流思想、倾诉情感与心声的平台，是公司为员工与行政领导的沟通架起的又一座便捷桥梁，更是我们员工直接参与企业内部民主管理的务实便利的渠道。</span>
</p>
<p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgb(51, 51, 51); font-family: Arial, 宋体; font-size: 12px; text-indent: 24px; white-space: normal; background-color: rgb(255, 255, 255); line-height: 1.75em;">
<span style="font-size: 12px;">我们真诚希望，各位会员在工作结束后的休憩时刻，或在偶因情绪不佳烦心时，记得这里还有一个抚慰心灵的港湾。我们更期待，各位会员把身边的奇闻趣事、心情随想、家庭天伦之乐、文娱活动等，通过工会内网平台的相关栏目与大家共享。</span>
</p>
<p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgb(51, 51, 51); font-family: Arial, 宋体; font-size: 12px; text-indent: 24px; white-space: normal; background-color: rgb(255, 255, 255); line-height: 1.75em;">
<span style="font-size: 12px;">在大家的热忱关爱与精心呵护下，相信我们的工会能够更加了解大家的喜好，并健康茁壮地成长。</span>
</p>
<p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; color: rgb(51, 51, 51); font-family: Arial, 宋体; font-size: 12px; text-indent: 24px; white-space: normal; background-color: rgb(255, 255, 255); line-height: 1.75em;">
<span style="font-size: 12px;">祝全体工会会员身体健康，家庭幸福。</span>
</p>
`;

const confirmHtml = `
使用本站的服务即表示您同意本站可以按照我们的隐私权政策使用您的个人数据。
<br>
<br>
收集信息的目的：
我们收集信息是为了向所有用户提供更好的服务，这既包括获取一些基本的信息（例如您使用的语言），也包括更为复杂的信息（例如工会福利及补助发放等）。
<br>
<br>
我们有两种信息收集方式：
您向我们提供信息。一些服务要求您注册帐户。而在您注册帐户时，我们会要求您提供个人信息，例如您的姓名、电子邮件地址、电话号码。如果您想要充分利用我们提供的各种分享功能，可能还需要创建公开显示的个人资料，其中会包含您的姓名和照片。
我们在您使用服务的过程中获取信息。我们会收集关于您使用的服务以及使用方式的信息，例如您在何时访问了使用我们的的网站，或者您在何时查看了我们的平台和内容并与之互动。此类信息包括：设备信息、日志信息、位置信息、本地存储、Cookie 和匿名标识符。
<br>
<br>
使用收集到的信息：
我们利用从所有服务中收集的信息来提供、维护、保护和改进这些服务，同时开发新的服务并保护本站以及用户。我们还会使用此类信息为您提供定制内容。
我们不会与本站以外的任何公司、组织和个人分享用户的个人信息，但是以下情况除外：征得您的同意；出于法律原因。
<br>
<br>
信息安全：
我们努力为用户提供保护，以免我们保存的信息在未经授权的情况下被访问、篡改、披露或破坏。
我们只允许那些为了帮我们处理个人信息而需要知晓这些信息的员工、承包商和代理商访问个人信息，而且他们需要履行严格的合同保密义务，如果其未能履行这些义务，就可能会被追究法律责任。
<br>
<br>
变更：
我们的隐私权政策随时都可能变更。未经您明确同意，我们不会削减您按照本隐私权政策所应享有的权利。我们会在本页面上发布对隐私权政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知。
`;

const platHtml=`<p style="text-align: center;"><strong>积分兑换平台使用须知</strong></p>
<p><span style="font-size: 14px;">1．自2018年11月22日起，工会慰问将以积分形式发放到会员个人账户。</span></p>
<p><span style="font-size: 14px;">2．会员可以前往积分兑换平台，使用个人账户内的积分兑换商品或服务。积分仅可用于兑换商品或服务，不能折现、提现。同样地平台也不支持现金充值等购物和兑换积分的形式。</span></p>
<p><span style="font-size: 14px;">3．每位会员每年度内，只能向其他会员转让积分1次，接受转让积分1次。</span></p>
<p><span style="font-size: 14px;">4．目前积分兑换平台有京东（京东大集，京东外卖，京东健康）和东方福利两个积分兑换渠道，商品和服务的退、换、改政策及运费收取规则均参照兑换渠道本身的政策和规则。</span></p>
<p><span style="font-size: 14px;">5．京东大集和京东外卖两个子频道，支持京东福粒（罗氏工会积分）支付，京东E卡及个人账户现金混合叠加支付，享受企业客户专属价格，请务必确保工会平台上登记的手机号和在京东平台上注册的手机号码是同一个，以便身份识别及罗氏工会平台的积分数据读取。</span></p>
<p><span style="font-size: 14px;">6．工会积分兑换平台，原则上会在每年12月的第三个星期日的零点清零，如有调整，请关注当月的工会信息推送，并在清零前妥善安排积分的使用。</span></p>
<p><span style="font-size: 14px;">7．会员可以前往工会网站或罗氏企业微信端工会频道进行积分捐赠（含未使用完的积分）。捐赠到工会公益账户的积分，将用于工会公益活动。</span></p>
<p><span style="font-size: 14px;">8．会员离职后，兑换平台账户自动关闭。离职，或因转岗成为非会员前，请确认积分使用情况，以避免系统自动清零。</span></p>
<p><span style="font-size: 14px;">9．积分兑换平台等待支付的订单，可自行取消。在确认支付前，请务必核对收货人的信息，包括收货地址，联系电话等，避免支付后再取消订单或退换货。</span></p>
<p><span style="font-size: 14px;">10．原则上已支付的订单不建议进行取消或退换，如有商品或服务质量的问题，请务必先联系对应渠道的客服。（京东健康不支持退换货）</span></p>
<p><span style="font-size: 14px;">京东专属罗氏客服邮箱：Issupport@jd.com，京东客服热线：400-606-9068。</span></p>
<p><span style="font-size: 14px;">东方福利专属罗氏客服邮箱：zhangyongfei@dongfangfuli.com，东方福利客服热线：400-618-2999。</span></p>
<p><span style="font-size: 14px;">京东健康客服热线：950619-8，也可在线咨询京东健康客服。</span></p>
<p><span style="font-size: 14px;color: red;font-weight: bold;">11．由于退换货所造成的退回积分，在对应渠道提示退货成功的次日，将自动退回至个人账户。</span></p>
<p><span style="font-size: 14px;">12．年度个调税请自行申报办理。</span></p>
<p><span style="font-size: 14px;">13．工会福利积分兑换平台内部联系方式：电话：021-28922999转2，邮箱地址：china.tradeunion@roche.com，会将问题记录后给予回复。</span></p>
<p><span style="font-size: 14px;">14．小程序使用故障或者疑问，请致电热线17717594166;17717612455，邮箱地址:service@srpltradeunion.com，服务时间:周一至周五 9：30-17：30</span></p>
`;

const MingZu = [{
        "label": "汉族",
        "value": "汉族",
    },
    {
        "label": "蒙古族",
        "value": "蒙古族"
    },
    {
        "label": "彝族",
        "value": "彝族"
    },
    {
        "label": "侗族",
        "value": "侗族"
    },
    {
        "label": "哈萨克族",
        "value": "哈萨克族"
    },
    {
        "label": "畲族",
        "value": "畲族"
    },
    {
        "label": "纳西族",
        "value": "纳西族"
    },
    {
        "label": "仫佬族",
        "value": "仫佬族"
    },
    {
        "label": "仡佬族",
        "value": "仡佬族"
    },
    {
        "label": "怒族",
        "value": "怒族"
    },
    {
        "label": "保安族",
        "value": "保安族"
    },
    {
        "label": "鄂伦春族",
        "value": "鄂伦春族"
    },
    {
        "label": "回族",
        "value": "回族"
    },
    {
        "label": "壮族",
        "value": "壮族"
    },
    {
        "label": "瑶族",
        "value": "瑶族"
    },
    {
        "label": "傣族",
        "value": "傣族"
    },
    {
        "label": "高山族",
        "value": "高山族"
    },
    {
        "label": "景颇族",
        "value": "景颇族"
    },
    {
        "label": "羌族",
        "value": "羌族"
    },
    {
        "label": "锡伯族",
        "value": "锡伯族"
    },
    {
        "label": "乌孜别克族",
        "value": "乌孜别克族"
    },
    {
        "label": "裕固族",
        "value": "裕固族"
    },
    {
        "label": "赫哲族",
        "value": "赫哲族"
    },
    {
        "label": "藏族",
        "value": "藏族"
    },
    {
        "label": "布依族",
        "value": "布依族"
    },
    {
        "label": "白族",
        "value": "白族"
    },
    {
        "label": "黎族",
        "value": "黎族"
    },
    {
        "label": "拉祜族",
        "value": "拉祜族"
    },
    {
        "label": "柯尔克孜族",
        "value": "柯尔克孜族"
    },
    {
        "label": "布朗族",
        "value": "布朗族"
    },
    {
        "label": "阿昌族",
        "value": "阿昌族"
    },
    {
        "label": "俄罗斯族",
        "value": "俄罗斯族"
    },
    {
        "label": "京族",
        "value": "京族"
    },
    {
        "label": "门巴族",
        "value": "门巴族"
    },
    {
        "label": "维吾尔族",
        "value": "维吾尔族"
    },
    {
        "label": "朝鲜族",
        "value": "朝鲜族"
    },
    {
        "label": "土家族",
        "value": "土家族"
    },
    {
        "label": "傈僳族",
        "value": "傈僳族"
    },
    {
        "label": "水族",
        "value": "水族"
    },
    {
        "label": "土族",
        "value": "土族"
    },
    {
        "label": "撒拉族",
        "value": "撒拉族"
    },
    {
        "label": "普米族",
        "value": "普米族"
    },
    {
        "label": "鄂温克族",
        "value": "鄂温克族"
    },
    {
        "label": "塔塔尔族",
        "value": "塔塔尔族"
    },
    {
        "label": "珞巴族",
        "value": "珞巴族"
    },
    {
        "label": "苗族",
        "value": "苗族"
    },
    {
        "label": "满族",
        "value": "满族"
    },
    {
        "label": "哈尼族",
        "value": "哈尼族"
    },
    {
        "label": "佤族",
        "value": "佤族"
    },
    {
        "label": "东乡族",
        "value": "东乡族"
    },
    {
        "label": "达斡尔族",
        "value": "达斡尔族"
    },
    {
        "label": "毛南族",
        "value": "毛南族"
    },
    {
        "label": "塔吉克族",
        "value": "塔吉克族"
    },
    {
        "label": "德昂族",
        "value": "德昂族"
    },
    {
        "label": "独龙族",
        "value": "独龙族"
    },
    {
        "label": "基诺族",
        "value": "基诺族"
    }
];

const education = [{
        label: "博士研究生",
        value: "博士研究生"
    },
    {
        label: "硕士研究生",
        value: "硕士研究生"
    },
    {
        label: "本科",
        value: "本科"
    },
    {
        label: "专科",
        value: "专科"
    },
    {
        label: "中技",
        value: "中技"
    },
    {
        label: "职校",
        value: "职校"
    },
    {
        label: "中专",
        value: "中专"
    },
    {
        label: "高级中学",
        value: "高级中学"
    },
    {
        label: "初级中学",
        value: "初级中学"
    },
    {
        label: "小学",
        value: "小学"
    },
];

const Politics = [{
        label: "群众",
        value: "群众"
    },
    {
        label: "党员",
        value: "党员"
    },
];
const CreateServiceCard = [{
        label: "愿意",
        value: "愿意"
    },
    {
        label: "不愿意",
        value: "不愿意"
    },
];


export default {
    LETTER_TEXT,
    confirmHtml,
    platHtml,
    MingZu,
    education,
    Politics,
    CreateServiceCard
}